<template>
  <div>
    <h1>引导安装页面</h1>
    <h2>第一</h2>
    <h2>第二</h2>
    <h2>第三</h2>
    <h2>第四</h2>
    <h2>完成注册</h2>
  </div>
</template>

<script>
export default {
  name: "Install"
};
</script>

<style lang="scss" scoped></style>
